/* Sections that arrive, instead of just being there
   ===========================================================================
   The old theme ran `animate_sections: true` with `animate_sections_text_style:
   rise-up`, so every section eased in as it came into view. That was Motion's
   own JavaScript and none of it can come across, so the shop's theme pages --
   collection, cart, search, blog, product -- ended up with no reveal at all.
   The custom sections on the homepage bring their own motion and never noticed;
   everything else did.

   THE RULE THAT SHAPES THIS FILE: CONTENT IS NEVER HIDDEN BY DEFAULT.

   The obvious way to build this is `opacity: 0` in the stylesheet and a class
   that turns it on. That is also the way that hides the entire shop from
   anyone whose JavaScript fails, and hands a crawler a page of invisible text
   -- which is exactly the SEO trap flagged for the tool pages. So:

     * the CSS that hides anything lives behind `.itv-reveal-ready` on <html>,
       and only this script ever adds that class. No script, no hiding.
     * a failsafe reveals everything after 2s no matter what the observer did.
     * `IntersectionObserver` missing, or reduced motion requested, and the
       script returns before touching the document at all.

   Any one of those failing still leaves a fully visible page. */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var FAILSAFE_MS = 2000;

  function run() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    var sections = [];
    var kids = main.children;
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (!el.classList || !el.classList.contains('shopify-section')) continue;

      /* Tool pages are hand-built documents with their own stylesheets, and
         several are canvas apps running their own animation loops. The theme
         does not animate them -- the same boundary every other file here
         respects. */
      if (el.querySelector('.itv-tool__stage, .itv-page__body')) continue;

      /* A section that already animates itself does not need a second system
         fighting it -- the homepage sections all fall out here. */
      if (el.querySelector('[class*="hero-pro"], .iv-momentum-terminal, canvas')) continue;

      sections.push(el);
    }
    /* Images are handled whether or not any section qualifies -- on the home
       page every section animates itself and is skipped, and the first
       version returned before it ever reached the images. */
    document.documentElement.classList.add('itv-reveal-ready');
    revealImages(main);

    if (!sections.length) return;
    for (var j = 0; j < sections.length; j++) sections[j].classList.add('itv-reveal');

    var reveal = function (el, delay) {
      if (el.classList.contains('itv-in')) return;
      if (delay) el.style.transitionDelay = delay + 'ms';
      el.classList.add('itv-in');
    };

    var io = new IntersectionObserver(function (entries) {
      /* Sorted by position so a screen holding three sections staggers top to
         bottom rather than in whatever order the observer reports them. */
      entries.sort(function (a, b) { return a.boundingClientRect.top - b.boundingClientRect.top; });
      var n = 0;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        reveal(entry.target, Math.min(n++ * 70, 210));
        io.unobserve(entry.target);
      });
    }, {
      /* Fires slightly before the section reaches the viewport, so the motion
         finishes as it arrives rather than starting once it is already read. */
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.01
    });

    for (var k = 0; k < sections.length; k++) io.observe(sections[k]);

    /* Whatever happened above, nothing stays invisible. */
    setTimeout(function () {
      for (var m = 0; m < sections.length; m++) reveal(sections[m], 0);
    }, FAILSAFE_MS);
  }

  /* ---------------------------------------------------------------- images
     The old theme ran `animate_images: true` with `animate_images_style:
     zoom-fade`. Measured on the live store: a 0.5s reveal with
     `fill: forwards` on roughly 36 images per page. The rebuild had none, and
     one small effect missing three dozen times per screen is most of what
     "lots of little animations are gone" actually means.

     REVEALED ON LOAD, NOT ON SCROLL, and that distinction is the whole
     design. The first version hid every image immediately and relied on an
     IntersectionObserver to bring each one back; anything the observer missed
     stayed invisible. check-reveal.mjs measured 19 of 20 homepage images
     still transparent after scrolling. Tying the reveal to the load event
     removes that entire class of failure:

       * an image already decoded when this runs is NEVER hidden -- it is
         simply left alone, so nothing that is on screen can be taken away;
       * an image not yet decoded is invisible anyway, so hiding it costs
         nothing and the fade is what the visitor sees when it arrives;
       * lazy-loaded images fade in as they load while scrolling, which is
         the behaviour the old setting produced.

     Reimplemented from the measurement. None of Motion's CSS is carried
     across -- a fade with a slight scale is generic behaviour. */
  function revealImages(main) {
    var imgs = main.querySelectorAll('img');

    var show = function (img) {
      img.classList.add('itv-img-in');
    };

    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.closest('.itv-tool__stage, .itv-page__body')) continue;

      /* Icons and payment marks: animating them reads as a glitch. */
      var w = img.getAttribute('width');
      if (w && parseInt(w, 10) < 60) continue;

      /* Images DELIBERATELY transparent at rest -- a collection card's second
         photo, shown on hover. The reveal sets opacity:1 at a higher
         specificity than the card's own opacity:0, so animating them does not
         merely add motion, it pins them visible and destroys the hover swap,
         leaving both photos stacked. Caught by check-reveal.mjs. */
      if (img.matches('[class*="secondary"], [class*="hover"], [class*="alt-img"]')) continue;

      /* Already painted -- leave it completely alone. */
      if (img.complete && img.naturalWidth > 0) continue;

      img.classList.add('itv-img');
      (function (el) {
        el.addEventListener('load', function () { show(el); }, { once: true });
        el.addEventListener('error', function () { show(el); }, { once: true });
        /* Decoded between the check above and the listener attaching. */
        if (el.complete) show(el);
      })(img);
    }

    /* Nothing stays invisible because an event was missed. */
    setTimeout(function () {
      var all = main.querySelectorAll('img.itv-img');
      for (var k = 0; k < all.length; k++) show(all[k]);
    }, FAILSAFE_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
